import React, { useEffect } from "react";
import { useEventsContext } from "../../../../context/eventsContext";
import UpcomingPlaceholder from "../elements/UpcomingPlaceholder";
import EventHero from "../EventHero";
import { loadUpcomingEvents } from "../../../../context/eventsContext/actions";

interface IUpcomingEventsProps {
  className?: string;
  upcoming_events?: any[];
}

const UpcomingEvents = ({ className, upcoming_events }: IUpcomingEventsProps) => {
  const {
    dispatch: eventsDispatch,
  } = useEventsContext();

  useEffect(() => {
      loadUpcomingEvents(eventsDispatch, upcoming_events);
  }, [eventsDispatch, upcoming_events]);

  return (
    <div>
      <h1 className={`text-xl md:text-3xl font-light w-full leading-1 pb-4 ${className}`}>
        Upcoming Events
      </h1>
      {
        <div className="space-y-4">
          {
            upcoming_events && upcoming_events.length > 0 ?
            [...upcoming_events].map((event) => (
              <EventHero 
                key={event.slug}
                event={event}
              />
            ))
            :
            <UpcomingPlaceholder />
          }
        </div>
      }
    </div>
  )
}

export default UpcomingEvents;
